import { IPartialLocaleValues } from "../interfaces/values";

const enUS:IPartialLocaleValues = {
    datepicker: {
        firstDayOfWeek: 0,
        formats: {
            time: "h:mm A",
            datetime: "MMMM D, YYYY h:mm A",
            date: "MMMM D, YYYY",
            month: "MMMM YYYY",
            year: "YYYY"
        }
    }
};

export default enUS;
